import { z } from 'zod'
import { Model } from './architecture'
import { SINGLE_ROOM } from '../booking/domain/Room'

export const RoomNumberValidation = z.object({
  value: z.number({ required_error: '[RoomNumber] value is required' }),
})

export class RoomNumber extends Model {
  static create({ value }: z.infer<typeof RoomNumberValidation>) {
    RoomNumberValidation.parse({ value })
    return new RoomNumber(value)
  }

  static fromNumber({ value = SINGLE_ROOM }: { value: number }) {
    return RoomNumber.create({ value })
  }

  constructor(private readonly _value: number) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  equals(roomNumber: RoomNumber) {
    return this.value === roomNumber.value
  }

  toJSON() {
    return { value: this.value }
  }
}
